import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Collapse, Stack } from '@mui/material';
import React, { useId, useState } from 'react';

export const PanelSlideDetails = ({
  panelId,
  slideCount,
  selectedCount,
  children,
}: {
  panelId: string;
  slideCount: number;
  selectedCount?: number;
  children: React.ReactNode;
}) => {
  const [expanded, setExpanded] = useState(false);
  const detailsId = useId();
  return (
    <Stack spacing={1}>
      <Button
        color="inherit"
        variant="text"
        aria-label={`Slide details for ${panelId}`}
        aria-expanded={expanded}
        aria-controls={detailsId}
        startIcon={<ExpandMoreIcon sx={{ transform: expanded ? 'rotate(180deg)' : 'none' }} />}
        sx={{ alignSelf: 'flex-start' }}
        onClick={() => setExpanded((current) => !current)}
      >
        {slideCount} {slideCount === 1 ? 'slide' : 'slides'}
        {selectedCount !== undefined ? ` · ${selectedCount} selected` : ''}
      </Button>
      <Collapse id={detailsId} in={expanded} mountOnEnter unmountOnExit>
        <Stack spacing={1}>{children}</Stack>
      </Collapse>
    </Stack>
  );
};
